<!--关于页面 Sag 2020-03-25-->
<template>
  <div class="its-about">
    <about-header :about="headerItem"></about-header>
    <about-e-class :item="eClassItem" id="aboutEClass"></about-e-class>
    <about-connect-us :item="connectItem"></about-connect-us>
    <about-map :item="mapItem"></about-map>
  </div>
</template>
<script>
import AboutHeader from './components/AboutHeader'
import AboutEClass from './components/AboutEClass'
import AboutConnectUs from './components/AboutConnectUs'
import AboutMap from './components/AboutMap'
export default {
  name: 'About',
  components: {
    AboutHeader,
    AboutEClass,
    AboutConnectUs,
    AboutMap
  },
  data(){
    return {
      headerItem : {
        title: '关于学科网',
        user: '陈学艺博士',
        intro: '学科网创始人、总经理',
        desc: `<p class="its-about-title">学科网简介</p>
               <p class="its-about-desc its-about-intro-item">学科网（北京）股份有限公司由归国博士陈学艺先生创办于2004年，是国家双软认定企业、北京市高新技术企业。作为领先的优质资源及智慧教学服务商，学科网综合教育资源、智能应用软件产品为中小学智慧教学提供先进的解决方案，致力于让教与学更高效。</p>
               <p class="its-about-title">学科网创始人</p>
               <p class="its-about-desc its-about-intro-item">陈学艺，瑞士苏黎世联邦理工学院（ETHZ）理学博士，学科网创始人，北京教育信息化产业联盟执行理事长，先后荣获江苏省双创计划领军人物、江苏省博士集聚计划、中国杰出贡献教育人物、教育企业风云人物等荣誉。</p>`
      },
      eClassItem : {
        title: '好内容+好平台 更懂您的智慧教学',
        desc: '<div class="its-about-intro-item"><span class="its-strong">学科网e课堂</span>基于学科网精品内容资源优势，融合大数据、AI等技术，打通“教、学、管、评、测、研”智慧教学闭环，辅助教师精准教学，实现学生个性化成长，助力区域、学校智慧化管理，帮助家长实时获取孩子在校动态，构建三位一体的智慧教学模式。</div><div class="its-about-intro-item">致力于赋能传统教学，助力教育信息化发展，让教与学更高效。其用户覆盖山西、河北、河南、江苏、安徽、广东、宁夏、新疆等地区，已成为广大用户青睐的智慧教学解决方案。</div><div class="its-about-intro-item">心有格局，方能志存高远。学科网e课堂愿与各教育同仁携手并肩，为打造更优质的信息化教学产品而努力！</div>'
      },
      connectItem: {
        title: '联系我们',
        desc: '我们为您提供了包括QQ、微信、400电话、电子邮件等多种联系方式，以便您可以随时联系到我们。我们一直在您身边！',
        contacts: [
          {
            name:'总  机',
            num: '010-56171882'
          },
          {
            name:'总  机',
            num: '400-900-2556转3',
            hideName: true
          },
          {
            name:'Email',
            num: '806958954@qq.com'
          }
        ],
        QQ: [
          {
            name:'魏老师',
            qq: '806958954'
          },
          {
            name:'李老师',
            qq: '806779394'
          },
          {
            name:'王老师',
            qq: '809401207'
          }
        ]
      },
      mapItem: {
        address: '总部地址：北京市房山区良乡长虹西路33号首发物流商务楼B座',
        postalCode: '邮编：102488'
      }
    }
  },
  mounted () {
    this.offsetTop = document.querySelector('#aboutEClass').offsetTop - 1
    window.addEventListener('scroll', this.handleScroll)
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
  },
  methods:{
    handleScroll: function(){
      this.$root.setHeaderBackground()
    }
  }

}
</script>
<style scoped>
.its-about{
  background-color: #F5F9FF;
}
</style>
